<template>
  <v-layout row wrap align-content-start fill-height class="pa-4">
    <v-flex xs12 class="page-head-container mb-3">
      <v-flex xs12 class="mb-4 page-head-container">
        <h1 class="headline font-weight-light">Antispasmodic List</h1>
      </v-flex>

      <v-flex xs12 class="search-container">
        <v-text-field
          :label="$t('common.search')"
          solo
          flat
          hide-details
          v-model="search"
        ></v-text-field>
      </v-flex>

      <v-flex xs12>
        <template>
          <v-data-table
            v-if="getAntispasmodics.length > 0"
            :headers="headers"
            :items="getAntispasmodics"
            :pagination.sync="pagination"
            :search="search"
            hide-actions
            class="my-4"
            :disable-initial-sort=true >


            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  id="antispasmodic"
                  v-for="header in headers"
                  :key="header.text"
                  :class="['column sortable', pagination.order ? 'desc' : 'asc', header.value === pagination.title ? 'active' : '']"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="props">
              <tr @click="clickItem(props.item)">
                <td>
                  <v-edit-dialog
                    :return-value.sync="props.item.antispasmodic"
                    lazy
                    @save="updateAntispasmodic(props.item.id, 'antispasmodic', tempItem.antispasmodic)"
                  > {{ props.item.antispasmodic }}
                    <v-text-field
                      slot="input"
                      v-model="tempItem.antispasmodic"
                      label="Edit"
                      single-line
                    ></v-text-field>
                  </v-edit-dialog>
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
      </v-flex>
    </v-flex>

    <v-btn icon fixed bottom right fab color="primary" @click="addAntispasmodic">
      <v-icon>add</v-icon>
    </v-btn>

    <v-snackbar
      v-model="snackbar"
      bottom
      :timeout="timeout"
      color="green"
    >
      New Antispasmodic Added
    </v-snackbar>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'AdminAntispasmodicList',
    data() {
      return {
        search: '',
        pagination: {
          rowsPerPage: -1,
          title:'',
          order:false
        },
        headers: [
          {
            text: 'Antispasmodic',
            align: 'left',
            value: 'antispasmodic',
            // sortable: false
          }
        ],
        snackbar: false,
        timeout: 3000,
        tempItem:'',
        tempValue:''
      }
    },

    computed: {
      ...mapGetters('antispasmodics', [
        'getAntispasmodics'
      ])
    },

    created () {
      this.fetchAntispasmodics()
    },

    methods: {
      ...mapActions('antispasmodics', [
        'fetchAntispasmodics'
      ]),
      changeSort (column) {
        if(column===''){return;}
        if (this.pagination.title === column) {
          this.pagination.order = !this.pagination.order
        } else {
          this.pagination.title = column
          this.pagination.order = false
        }
        this.$store.dispatch('antispasmodics/sortAntispasmodic', {title:column,order:this.pagination.order})

      },

      updateAntispasmodic ( antispasmodicID, field, value ) {
        // console.log(antispasmodicID,field,value)
        const updateObj = {
          antispasmodicID: antispasmodicID,
          field: field,
          value: value
        }
        
        this.$store.dispatch('antispasmodics/updateColumnById', updateObj)
      },

      async addAntispasmodic () {
        try {
          await this.$store.dispatch('antispasmodics/addAntispasmodic')
          this.snackbar = true
        } catch (e) {
          this.snackbar = false
        }
      },
      clickItem(data){
        this.tempItem = Object.assign({}, data);
      }
    }
  }
</script>

<style lang="scss">
</style>